<template>
  <div>
    <div>
      <aha-modal
        @hide="hide()"
        :title="title_CreateNewFolder"
        action-position="justify-end"
      >
        <form @submit.prevent="handleCreateNewFolder()">
          <aha-input
            focus
            v-model="folderName"
            id="input_folder-name"
            :maxLength="limitFolderName"
            class="mt-1"
          />
        </form>
        <template #action>
          <aha-link @click="hide()">
            <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
          </aha-link>
          <aha-button
            :disabled="isCreatingFolder || folderName.length === 0"
            @click="handleCreateNewFolder()"
            icon-name="add"
            :submitting="isCreatingFolder"
            has-margin-left
          >
            <aha-spinner variant="white" v-if="isCreatingFolder" class="mr-1" />
            {{ $i18nPresenter.t("Create Folder") }}
          </aha-button>
        </template>
        <p class="pt-2 text-red-50" v-if="textError">
          {{ textError }}
        </p>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

// api
import FolderApi from '@/api/folder'

// utils
import utils from '@/util'
import EventBus from '@/eventBus'

// constants
import constants from '@/constant'

export default {
  props: {
    presentationIds: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      folderName: '',
      isCreatingFolder: false,
      limitFolderName: 100,
      textError: '',
      title_CreateNewFolder: this.$i18nPresenter.t('Create New Folder'),
    }
  },
  methods: {
    ...mapActions(['setErrorOnInternalServerAction']),
    trackEvent(label, value) {
      utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_LIST,
        label,
        value,
      )
    },
    async handleCreateNewFolder() {
      this.trackEvent('New > Create New Folder > Submit', `Folder name: ${this.folderName}`)

      if (this.folderName.trim() === '') {
        this.textError = this.$i18nPresenter.t('Please enter a name for folder.')
        return
      }

      this.isCreatingFolder = true

      try {
        const result = await FolderApi.createTeamFolder(this.$store.state.currentUser.accountId, {
          folderName: this.folderName.trim(),
        })
        if (this.presentationIds.length) {
          await this.handleMovePresnToNewFolder(result)
        } else {
          utils.showToastSuccess(`${this.$i18nPresenter.t('Created folder')} "${this.folderName.trim()}"`)
        }
        if (result.code === 'ok') utils.showToastSuccess(`${this.$i18nPresenter.t('Created folder')} "${this.folderName.trim()}"`)
        else utils.showToastError(`${this.$i18nPresenter.t('Created folder')} "${this.folderName.trim()} failed"`)
        this.hide()
        EventBus.$emit('reload-presentations-and-folders')
        utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'New > Create New Folder > Succeeded', null, null, {
          isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
          isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
          role: this.$store.state.currentUser.accountRole || null,
          teamId: this.$store.state.currentAccount.id || null,
          folderId: result.folder.folderId || null,
        })
      } catch (error) {
        if (error.body.message === 'folderName must be unique') {
          this.textError = this.$i18nPresenter.t('This folder name is already in use, please enter something else.')
        } else {
          this.setErrorOnInternalServerAction(`${this.$i18nPresenter.t('Cannot create folder: ')} ${this.folderName}`)
        }

        this.trackEvent('New > Create New Folder > Failed', `Error: ${error.body.message}`)
      }

      this.isCreatingFolder = false
    },
    async handleMovePresnToNewFolder(result) {
      const params = {
        presentationIds: this.presentationIds,
        folderId: result.folder.folderId,
      }
      try {
        await FolderApi.moveTeamPresentation(
          this.$store.state.currentAccount.id,
          params,
        )
      } catch (error) {
        utils.showToastError(this.$i18nPresenter.t('Move presentations failed'))
        this.trackEvent(
          'Presentation List > Move Presentation to new folder > Failed',
          error.body ? error.body.message : '',
        )
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
<style scoped lang="scss">
.must-have-icon {
  font-size: 6px;
  color: red;
  margin-left: 0.25rem;
}
</style>
